<template>
  <div class="edit-setting-select-box">
    <span class="common-label">{{ labelText }}</span>
    <div
      class="common-select"
    >
      <select class="form-control" :value="value" @change="changeCount($event.target.value)">
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'value',
  ],
  data () {
    return {
      options: [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
      ],
    }
  },
  computed: {
    labelText () {
      return 'カラム数'
    },
  },
  methods: {
    changeCount (newValue) {
      this.$emit('changeCount', {
        oldValue: this.value,
        newValue: Number(newValue)
      })
    }
  }
}
</script>
